import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MonthlyReport } from 'src/app/components/client/institution-monthly-report/monthly-report.models';
import { BaseApiEndpoint } from './base-endpoint';

export class MonthlyReportEndpoint extends BaseApiEndpoint {
  getMonthlyReport(clientServiceId: number, yearMonth: string): Observable<MonthlyReport> {
    const params = new HttpParams().set('yearMonth', yearMonth);
    return this._http
      .get<{ data: MonthlyReport }>(`${this.path}${clientServiceId}/monthly-report`, { params })
      .pipe(map((res) => res.data));
  }
}
